/**
 * Tenant status values
 */
export enum TenantStatusEnum {
  /** In trial. */
  TRIALING = 'trialing',
  /** Active and in good standing. */
  ACTIVE = 'active',
  /** Payment failed; still in grace. */
  PAST_DUE = 'past-due',
  /** Retries exhausted / uncollectible. */
  UNPAID = 'unpaid',
  /** Dormant / collection paused. */
  PAUSED = 'paused',
  /** Churned / contract ended. */
  CANCELED = 'canceled',
}
